<template>
    <div class="rightFix hidden-md-and-down">
        <a href="tencent://message/?uin=79612902&amp;Site=sc.chinaz.com&amp;Menu=yes">
            <div class="box main-flex above">
                <img :src="qq" alt="">
                <p>在线沟通</p>
            </div>
        </a>

        <!-- <div class="box main-flex below" @click="toTop({event:$event})"> -->
        <div class="box main-flex below" @click="toTop">
            <i class="el-icon-arrow-up"></i>
        </div>
    </div>
</template>

<script>
// import { mapState, mapActions } from 'vuex'

export default {
    data(){
        return{
            qq: require('@/assets/q.png'),
            scrollTop: 0,
            time: 0,
            dParams: 20,
            scrollState: 0
        }
    },
    // computed:{
    //     ...mapState({
    //         scrollTop: state => state.goTop.scrollTop,
    //         time: state => state.goTop.time,
    //         dParams: state => state.goTop.dParams,
    //         scrollState: state => state.goTop.scrollState
    //     })
    // },
    created(){
        // console.log("this.scrollTop",this.scrollTop)
    },
    mounted(){
        // window.addEventListener('scroll', ()=>{this.scrollTop});
        window.addEventListener('scroll',this.getScrollTop)
    },
    methods:{
        // ...mapActions({
        //     toTop: 'goTop/toTop',
        //     gotoTop: 'goTop/gotoTop' 
        // })
        toTop(e) {
            if(!!this.scrollState){
                return;
            }
            this.scrollState = 1;
            e.preventDefault();
            // let distance = document.documentElement.scrollTop || document.body.scrollTop;
            let _this = this;
            this.time = setInterval(function(){ _this.gotoTop(_this.scrollTop-_this.dParams) }, 10);
        },
        gotoTop(distance){
            this.dParams += 5;
            distance = distance>0 ? distance : 0;
            document.documentElement.scrollTop = document.body.scrollTop = window.pageYOffset = distance;
            if(this.scrollTop < 10){
                clearInterval(this.time);
                this.dParams = 5;
                this.scrollState = 0;
            }
        },
        getScrollTop() {
            this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        }
    }
    
}
</script>

<style lang="scss" scoped>
.rightFix{
    position: fixed;
    top: vw(330);
    right: 0;

    .box{
        min-width: vw(70);
        height: vw(70);
        flex-direction: column;
        align-items: center;
        margin-bottom: 1px;
        cursor: pointer;
        color: white;
        // background: $yyBlue;
        background: linear-gradient(180deg, rgba(37,99,175,.8), $yyBlue);
    }

    .above{
        img{
            width: vw(32);
        }
        p{
            font-size: vw(12);
            margin: 0;
        }
    }

    .below{
        font-size: vw(44);
    }
}
</style>